var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{class:_vm.cssClass,attrs:{"version":"1.1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","height":_vm.size,"width":_vm.size,"viewBox":'0 0 ' + _vm.size + ' ' + _vm.size},on:{"click":_vm.click}},[_c('use',{attrs:{"xlink:href":require('@/assets/img/sprite.svg') + '#' + _vm.variant}})])
}
var staticRenderFns = []

export { render, staticRenderFns }